import React, { useCallback, useState } from 'react';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

const KEY = 'ob_list_collapsed_cols';
const read = () => { try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return new Set(); } };

// Collapsed table columns, remembered per device.
export const useCollapsedCols = () => {
  const [collapsed, setCollapsed] = useState(read);
  const toggle = useCallback((k) => setCollapsed((prev) => {
    const next = new Set(prev);
    if (next.has(k)) next.delete(k); else next.add(k);
    localStorage.setItem(KEY, JSON.stringify([...next]));
    return next;
  }), []);
  return { collapsed, toggle };
};

export const CollapsibleTh = ({ col, label, collapsed, onToggle, className = '' }) => {
  const isOff = collapsed.has(col);
  const stop = (e) => { e.stopPropagation(); onToggle(col); };
  if (isOff) {
    return (
      <th className="w-7 px-0 py-2.5 text-center" data-testid={`ob-col-${col}-collapsed`}>
        <button type="button" onClick={stop} title={`Show ${label}`} aria-label={`Show ${label}`} data-testid={`ob-col-toggle-${col}`} className="inline-grid h-6 w-6 place-items-center rounded-md text-slate-400 transition-colors hover:bg-slate-200 hover:text-slate-700">
          <ChevronsRight className="h-3.5 w-3.5" />
        </button>
      </th>
    );
  }
  return (
    <th className={`px-3 py-2.5 ${className}`} data-testid={`ob-col-${col}`}>
      <span className="group/th inline-flex items-center gap-1 whitespace-nowrap">
        {label}
        <button type="button" onClick={stop} title={`Collapse ${label}`} aria-label={`Collapse ${label}`} data-testid={`ob-col-toggle-${col}`} className="inline-grid h-5 w-5 place-items-center rounded text-slate-300 transition-colors hover:bg-slate-200 hover:text-slate-700">
          <ChevronsLeft className="h-3.5 w-3.5" />
        </button>
      </span>
    </th>
  );
};

// Renders the cell, or a thin empty strip when its column is collapsed.
export const ColTd = ({ col, collapsed, className = 'px-3 py-2.5', children, ...rest }) => (
  collapsed.has(col)
    ? <td className="w-7 bg-slate-50/50 px-0" aria-hidden="true" />
    : <td className={className} {...rest}>{children}</td>
);
